// import { type EmployeeBody, type RegisterData } from 'types';
import ApiUtil from '../utils/ApiUtil';
import { type OganizationAttributesType } from 'types/services';
import { economicStatus, employerServiceUrls } from 'constants/apiEndPoints';
import QueryParamsBuilder from 'components/helpers/commonFunctions/QueryParamsBuilder';
import { type economicStatusAndOccupation } from 'types/pages';

const createOrganization = async (data: OganizationAttributesType): Promise<OganizationAttributesType> => {
    return await ApiUtil.postWithToken('employer/create', data) as OganizationAttributesType;

}

const updateOrganizationService = async (id: number, body: OganizationAttributesType): Promise<OganizationAttributesType> => {
    return await ApiUtil.postWithToken(`employer/update/${id}`, body) as OganizationAttributesType;

}

const updateOrganizationIsActive = async (id: number, body: OganizationAttributesType): Promise<OganizationAttributesType> => {
    return await ApiUtil.postWithToken(`employer/isactive/${id}`, body) as OganizationAttributesType;

}
const getAllOganizationData = async (
    { page, size, sortBy, sortOrder, searchValue }: {
        page: number;
        size: number;
        sortBy?: string;
        sortOrder?: string;
        searchValue?: string;
    }
): Promise<OganizationAttributesType[]> => {
    const apiUrl = QueryParamsBuilder({ baseUrl: employerServiceUrls.getAllEmployers, page, size, sortBy, sortOrder, searchValue });
    return await ApiUtil.getWithToken(apiUrl) as OganizationAttributesType[];
};

const getTotalEmp = async (): Promise<unknown> => {
    return await ApiUtil.getWithToken('/employee-count') as OganizationAttributesType;
}

const getOrganizationSearch = async (searchValue: string): Promise<unknown> => {
    return await ApiUtil.getWithToken(`employer-search?search=${searchValue}`) as OganizationAttributesType;
}

const getOganizationDataById = async (organizationId: number): Promise<OganizationAttributesType> =>
    await new Promise((resolve) => {
        const res = ApiUtil.getWithToken(`employer/${organizationId}`) as OganizationAttributesType;
        resolve(res);
    });
const getOrganizationDetailsOrgId = async (organizationId: number): Promise<OganizationAttributesType> => {
    return await
        ApiUtil.getWithToken(`employer/detail/${organizationId}`) as OganizationAttributesType;
};

const removeOganization = async (organizationId: number): Promise<object> => {

    const res = await ApiUtil.postWithToken(`employer-delete/${organizationId}`);
    return res;

};

const getEconomicStatusAndOccupation = async (): Promise<economicStatusAndOccupation> => {
    try {
        const result = await ApiUtil.getWithToken(economicStatus.employmentCategory) as economicStatusAndOccupation;
        return result;
    } catch (error) {
        throw new Error('Failed to fetch economic status and occupation');
    }
};



export {
    createOrganization,
    updateOrganizationService,
    getAllOganizationData,
    getOganizationDataById,
    removeOganization,
    updateOrganizationIsActive,
    getOrganizationDetailsOrgId,
    getEconomicStatusAndOccupation,
    getTotalEmp,
    getOrganizationSearch
};